import React, { useEffect, useState } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useParams } from "react-router-dom";

import { Get_All_From_Xero } from "../api/Get_All_From_Xero";
import { Test_One_Xero } from "../api/Test_One_Xero";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
// material-ui

function ViewTransaction() {
  const { id } = useParams();
  const { logout } = StaffuseAuth();

  let Arr_PropsToSee = [
    "_id",
    "Invoice_Number",
    "Contact",
    "Invoice_Date",
    "Due_Date",
    "Gross_GBP",
    "Status",
  ];

  const [Obj_Transaction, setObj_Transaction] = useState({
    _id: id,
    Invoice_Number: "",
    Contact: "",
    Invoice_Date: new Date().toISOString().split("T")[0],
    Due_Date: "",
    Gross_GBP: "",
    Status: "UnPaid",
    Staff_id: "",
    Handled: "UnHandled",
    Import_Date: new Date().toISOString().split("T")[0],
  });

  console.log(Obj_Transaction);

  useEffect(() => {
    if (id !== "AddTransaction") {
      Get_One_From_MongoDB(
        "Invoices",
        "Transactions_2025",
        id,
        setObj_Transaction,
        logout
      );
    }
  }, []);

  //The below gets the staff
  const [Arr_Staff, setArr_Staff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setArr_Staff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  // Function to handle changing the state of Invoice
  const handleChange = (event) => {
    setObj_Transaction({
      ...Obj_Transaction,
      [event.target.name]: event.target.value,
    });
  };

  const handleHandledChange = (event) => {
    if (event.target.value === "Handled") {
      setObj_Transaction({
        ...Obj_Transaction,
        [event.target.name]: event.target.value,
        Staff_id: localStorage.getItem("_id"),
      });
    } else if (event.target.value === "UnHandled") {
      setObj_Transaction({
        ...Obj_Transaction,
        [event.target.name]: event.target.value,
        Staff_id: "",
      });
    } else {
      setObj_Transaction({
        ...Obj_Transaction,
        [event.target.name]: event.target.value,
      });
    }
  };

  const [isSubmitting, setisSubmitting] = useState(false);

  function handleAddTransaction() {
    let data = Obj_Transaction;
    delete data._id;
    Post_To_MongoDB(
      data,
      "Invoices",
      "Transactions_2025",
      setisSubmitting,
      logout
    );
  }

  function handleUpdateTransaction() {
    let data = Obj_Transaction;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Invoices",
      "Transactions_2025",
      setisSubmitting,
      id,
      logout
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Invoices</h1>
        <h2>Add/Update Transaction</h2>
        {/* Basic Info */}
        <section>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                label="id"
                name="id"
                value={id}
                // onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                disabled={true}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                label="Invoice_Number"
                name="Invoice_Number"
                value={Obj_Transaction.Invoice_Number}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
              <TextField
                label="Contact"
                name="Contact"
                value={Obj_Transaction.Contact}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Invoice_Date"
                name="Invoice_Date"
                type="date"
                value={Obj_Transaction.Invoice_Date}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                label="Due_Date"
                name="Due_Date"
                type="date"
                value={Obj_Transaction.Due_Date}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                label="Import_Date"
                name="Import_Date"
                type="date"
                value={Obj_Transaction.Import_Date}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Gross_GBP"
                name="Gross_GBP"
                type="number"
                value={Obj_Transaction.Gross_GBP}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
              <TextField
                label="Status"
                name="Status"
                value={Obj_Transaction.Status}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                select
              >
                <MenuItem value="Paid">Paid</MenuItem>
                <MenuItem value="UnPaid">UnPaid</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Handled"
                name="Handled"
                value={Obj_Transaction.Handled}
                onChange={handleHandledChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                <MenuItem value="UnHandled">UnHandled</MenuItem>
                <MenuItem value="Handled">Handled</MenuItem>
              </TextField>
              <TextField
                label="Who Handled"
                name="Staff_id"
                value={Obj_Transaction.Staff_id}
                onChange={handleChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                {Arr_Staff.map((Obj_Staff) => (
                  <MenuItem key={Obj_Staff._id} value={Obj_Staff._id}>
                    {Obj_Staff.Username ? Obj_Staff.Username : ""}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </section>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "16px",
          }}
        >
          {id === "AddTransaction" ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddTransaction}
              //   disabled={!isFormValid}
              style={{ width: "50%" }}
            >
              {isSubmitting ? "Submitting..." : "Add Transaction"}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdateTransaction}
              //   disabled={!isFormValid}
              style={{ width: "50%" }}
            >
              {isSubmitting ? "Submitting..." : "Update Transaction"}
            </Button>
          )}
        </div>
      </section>
    </div>
  );
}

export default ViewTransaction;
